module.exports = __webpack_public_path__ + "img/sel_Guangzhou.70ca5b39.png";